// extracted by mini-css-extract-plugin
export default {"bullets":"bullets_bullets__WaMbo","bullets__sub":"bullets_bullets__sub__FTDK5","section__footer":"bullets_section__footer__zQGjp"};